import React from 'react';
import clsx from 'clsx';
import { useIntl, FormattedMessage } from 'react-intl';

const QueryClauseTableRowOr = ({ firstClause, isEditing }) => {
  const intl = useIntl();
  return (
    <div
      className={clsx(
        'aridhia-cohort-or help',
        !firstClause && 'aridhia-cohort-or--border',
        !isEditing && 'aridhia-cohort-or--no-edit',
      )}
      title={intl.formatMessage({ id: 'cohort.refine.or.tooltip' })}
    >
      <span>{!firstClause && <FormattedMessage id="cohort.refine.or" />}</span>
    </div>
  );
};

export default QueryClauseTableRowOr;
